// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/sites/modules/sites-detail/components/edit-site/edit-site.less
// module id = 4023
// module chunks = 0